export const NullValueCell = () => <div className="nullValue">---</div>;
